<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-search`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.65527 1.61523C10.8559 1.61533 13.4509 4.21053 13.4512 7.41113C13.4511 8.89562 12.8916 10.249 11.9736 11.2744L13.9463 13.248C14.206 13.5077 14.206 13.9288 13.9463 14.1885C13.6866 14.448 13.2655 14.4481 13.0059 14.1885L10.9766 12.1592C10.0358 12.8186 8.89125 13.207 7.65527 13.207C4.45454 13.2069 1.85947 10.6119 1.85938 7.41113C1.85962 4.21053 4.45464 1.61533 7.65527 1.61523ZM7.65527 2.94531C5.18918 2.94541 3.1897 4.94507 3.18945 7.41113C3.18954 9.87733 5.18908 11.8769 7.65527 11.877C10.1215 11.8769 12.121 9.87733 12.1211 7.41113C12.1208 4.94507 10.1214 2.9454 7.65527 2.94531Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineSearch',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
